var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCross = function SvgCross(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.13099 0.64564C9.4393 0.953949 9.4393 1.45382 9.13099 1.76212L1.7622 9.13092C1.45389 9.43923 0.954019 9.43923 0.64571 9.13092C0.337402 8.82261 0.337402 8.32274 0.645711 8.01444L8.01451 0.64564C8.32282 0.337332 8.82268 0.337332 9.13099 0.64564Z",
    fill: "#A1A3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35429 9.13092C9.04598 9.43923 8.54611 9.43923 8.2378 9.13092L0.869008 1.76212C0.5607 1.45382 0.5607 0.953948 0.869009 0.64564C1.17732 0.337331 1.67718 0.337331 1.98549 0.64564L9.35429 8.01444C9.6626 8.32275 9.6626 8.82261 9.35429 9.13092Z",
    fill: "#A1A3A7"
  })));
};
export default SvgCross;